export const UPDATE_FRAME_ADVISOR_STATUS = 'UPDATE_FRAME_ADVISOR_STATUS'
export const UPDATE_SIZE_ADVISOR_STATUS = 'UPDATE_SIZE_ADVISOR_STATUS'
export const SET_FRAME_GENIUS_ANALYSIS_RESULTS = 'SET_FRAME_GENIUS_ANALYSIS_RESULTS'
export const SET_FRAME_ADVISOR_SCRIPTS_LOADED_STATUS = 'SET_FRAME_ADVISOR_SCRIPTS_LOADED_STATUS'
export const SET_FRAME_ADVISOR_FLOATING_BUTTON_STATUS = 'SET_FRAME_ADVISOR_FLOATING_BUTTON_STATUS'
export const mutations = {
  [UPDATE_FRAME_ADVISOR_STATUS]: function (state, payload) {
    state.isFrameAdvisorOpen = payload
  },
  [UPDATE_SIZE_ADVISOR_STATUS]: function (state, payload) {
    state.isSizeAdvisorOpen = payload
  },
  [SET_FRAME_GENIUS_ANALYSIS_RESULTS]: function (state, payload) {
    state.analysisResults = payload
  },
  [SET_FRAME_ADVISOR_SCRIPTS_LOADED_STATUS]: function (state, payload) {
    state.areScriptsLoaded = payload
  },
  [SET_FRAME_ADVISOR_FLOATING_BUTTON_STATUS]: function (state, payload) {
    state.isFloatingButtonVisible = payload
  },
}
